import { Link } from 'react-router-dom'

const ShareButtonX = ({ path, text }) => {
  let url = window.location.origin +  path;

  // シェアURLを組み立てる
  const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url
  )}&text=${encodeURIComponent(text)}`;

  return (
    <Link to={shareUrl} target="_blank">
        <div className="share-button x-twitter">
            <img src="/assets/images/others/icon_x_share.svg"  />
        </div>
    </Link> 
  );
}
export default ShareButtonX
